// src/firebase.js
import { initializeApp, getApp, getApps } from "firebase/app";
import {
  getAuth,
  onAuthStateChanged,
  connectAuthEmulator,
  signInAnonymously,
} from "firebase/auth";
import {
  getFirestore,
  connectFirestoreEmulator,
} from "firebase/firestore";
import {
  getStorage,
  connectStorageEmulator,
} from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyAxagcTNG9mYws_9h0WLvKqmdRoP6pqh98",
  authDomain: "mkd-prod.firebaseapp.com",
  projectId: "mkd-prod",
  storageBucket: "mkd-prod.firebasestorage.app",
  messagingSenderId: "392665673866",
  appId: "1:392665673866:web:2f21eda0fd2ef81cbdfd73",
  measurementId: "G-8VCF7LXKJB",
};

// --- Initialisation unique ---
export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Petit util pour savoir si on est en local
const isLocalhost =
  typeof window !== "undefined" &&
  /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);

// --- DEV LOCAL : émulateurs + App Check debug + session anonyme ---
if (isLocalhost) {
  // 1) App Check en mode debug — utiliser 'window' (ou globalThis) au lieu de 'self'
  try {
    // décommente si tu fais respecter App Check sur Firestore/Storage
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true; // ✅ plus d'avertissement ESLint
    // globalThis.FIREBASE_APPCHECK_DEBUG_TOKEN = true; // alternative
  } catch {}

  // 2) Brancher les SDKs sur les émulateurs (si démarrés)
  try {
    connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  } catch {}
  try {
    connectFirestoreEmulator(db, "localhost", 8080);
  } catch {}
  try {
    connectStorageEmulator(storage, "localhost", 9199);
  } catch {}

  // 3) Être "authentifié" si tes règles exigent request.auth != null
  signInAnonymously(auth).catch(console.error);
}

// --- App Check (prod only) ---
// En local (localhost/127.0.0.1), on désactive App Check pour éviter le 403 debug token.
if (typeof window !== "undefined" && !isLocalhost) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6LckmrArAAAAAFFnsccj7UwXx3Wx-OOAKCO4b-VB"),
    isTokenAutoRefreshEnabled: true,
  });
}


// --- Helpers pratiques dans la console (optionnel) ---
if (typeof window !== "undefined") {
  globalThis.auth = auth;
  globalThis.db = db;
  globalThis.storage = storage;
  globalThis.showClaims = async () => {
    const u = auth.currentUser;
    if (!u) return console.log("Pas connecté");
    const t = await u.getIdTokenResult(true);
    console.log("claims:", t.claims);
    return t.claims;
  };
}

// --- Promesse: utilisateur + claims prêts ---
export const waitForClaims = new Promise((resolve) => {
  onAuthStateChanged(auth, async (user) => {
    if (!user) return resolve({ user: null, claims: null });
    const t = await user.getIdTokenResult(true);
    resolve({ user, claims: t.claims });
  });
});
